export interface OnCloseRelease {
  minutesSpent: number;
  minutesAfterExpansion: number;
  releaseNoteId: string;
}
